import { render, staticRenderFns } from "./InternalReply.vue?vue&type=template&id=5d4da33c"
import script from "./InternalReply.vue?vue&type=script&lang=js"
export * from "./InternalReply.vue?vue&type=script&lang=js"
import style0 from "./InternalReply.vue?vue&type=style&index=0&id=5d4da33c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports